import { createContext, useContext } from 'react';

export const ChannelShareContext = createContext();

export const useChannelShare = () => useContext(ChannelShareContext);
